<template>
  <v-container fluid class="py-0 my-0">
    <template v-if="!isLoading">
      <v-row>
        <template v-if="!$vuetify.breakpoint.mobile">
          <v-col>
            <v-col>
              <template v-for="(text, c) in textes.slice(0,3)">
                <span :key="c">
                  <b>Pour le {{moment(text.date).format('ddd DD MMM')}}</b> :  {{text.text}}<br/>
                  Températures : <b>{{Math.round(text.temp[0] *10)/ 10}}°C</b> / <b>{{Math.round(text.temp[1] * 10) / 10}}°C</b>. Pluie : <b>{{Math.round(text.rain * 10) / 10}}mm/j</b>. Vent moyen : <b>{{Math.round(text.wind * 3.6) }}km/h</b>. Rafales : <b>{{Math.round(text.gust * 3.6)}}km/h</b> <br/> <br/>
                </span>
              </template>
            </v-col>
            <v-row>
              <v-col class="px-0 mx-0 icons-table"> </v-col>

              <v-col
                class="border-right px-4"
                v-for="(fcast, b) in forecastsDay"
                :key="`fcast${b}`"
              >
                <v-row>
                  <!-- header -->
                  <v-col
                    cols="12"
                    class="rounded-lg text-center"
                    :class="
                      moment(fcast.date).format('d') === '6' ||
                      moment(fcast.date).format('d') === '0'
                        ? 'card-weather-1'
                        : 'card-weather-2'
                    "
                  >
                    <v-row>
                      <v-col cols="12"
                        ><v-img height="100px" contain :src="`${iconUrl(fcast.ts, false)}`"
                      /></v-col>
                      <v-col cols="12">
                        

                        <span class="font-weight-bold">{{
                          moment(fcast.date).format("ddd DD")
                        }}</span
                        ><br />
                        <span class="font-weight-bold">{{
                          moment(fcast.date).format("MMMM")
                        }}</span
                        ><br />

                        <span
                          >{{ fcast.tmin }} /
                          <span class="red--text">{{ fcast.tmax }}</span
                          >°C</span
                        ><br />
                        <span  v-if="$env.VUE_APP_WHITE_MARK_ID == 'monithermo'">
                        <B>DJU : {{ Math.abs(Math.round((fcast.tmin+fcast.tmax)/2-18)) }}
                          °C</B></span
                        ><br  v-if="$env.VUE_APP_WHITE_MARK_ID == 'monithermo'"/>
                        <span class="blue--text"
                          >{{
                            Math.round(fcast.apcpsfc * 100) / 100
                          }} mm/h</span
                        ><br />
                        <span
                          >{{ Math.round(fcast.wind_speed * 3.6) }}/<span
                            class="info--text"
                            >{{ Math.round(fcast.gustsfc * 3.6) }}</span
                          > km/h</span
                        >
                        <br />
                      </v-col>
                    </v-row>
                  </v-col>
                  <!-- <v-col cols=3></v-col> -->
                  <v-col cols="3" class="font-weight-bold text-center"
                    ><small style="font-size: 0.6em">Nuit</small></v-col
                  >
                  <v-col cols="3" class="font-weight-bold text-center"
                    ><small style="font-size: 0.6em">Mat.</small></v-col
                  >
                  <v-col cols="3" class="font-weight-bold text-center"
                    ><small style="font-size: 0.6em">Ap.Midi</small></v-col
                  >
                  <v-col cols="3" class="font-weight-bold text-center"
                    ><small style="font-size: 0.6em">Soir</small></v-col
                  >
                  <!-- data -->

                  <!-- <v-col cols=3></v-col> -->
                  <v-col cols="3" class="text-center pa-0"
                    ><v-img
                      contain
                      :src="`${iconUrl(getQuarter(fcast.date)[0].ts)}`"
                  /></v-col>
                  <v-col cols="3" class="text-center pa-0"
                    ><v-img
                      contain
                      :src="`${iconUrl(getQuarter(fcast.date)[1].ts)}`"
                  /></v-col>
                  <v-col cols="3" class="text-center pa-0"
                    ><v-img
                      contain
                      :src="`${iconUrl(getQuarter(fcast.date)[2].ts)}`"
                  /></v-col>
                  <v-col cols="3" class="text-center pa-0"
                    ><v-img
                      contain
                      :src="`${iconUrl(getQuarter(fcast.date)[3].ts)}`"
                  /></v-col>
                  <!-- road cond -->
                  <!-- -->
                  <v-col cols="3" class="text-center" v-if="user.features.includes('roadcast')">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attr }">
                        <v-icon
                          class="icon-float"
                          color="blue"
                          v-on="on"
                          v-bind="attr"
                          >mdi-road</v-icon
                        >
                      </template>
                      <span>Conditions de chaussée</span>
                    </v-tooltip>
                    <span :title="roadCondToLongTitle(findRoadcast(getQuarter(fcast.date)[0].timestamp, true))" :style="`color:rgb(${roadCondToColor(findRoadcast(fcast.timestamp, true))});`">{{ findRoadcast(getQuarter(fcast.date)[0].timestamp) || '-' }}</span>
                  </v-col>
                  <v-col v-if="user.features.includes('roadcast')" cols="3" class="text-center"> <span :title="roadCondToLongTitle(findRoadcast(getQuarter(fcast.date)[1].timestamp, true))" :style="`color:rgb(${roadCondToColor(findRoadcast(getQuarter(fcast.date)[1].timestamp, true))});`">{{ findRoadcast(getQuarter(fcast.date)[1].timestamp) || '-' }}</span></v-col>
                  <v-col v-if="user.features.includes('roadcast')" cols="3" class="text-center"> <span :title="roadCondToLongTitle(findRoadcast(getQuarter(fcast.date)[2].timestamp, true))" :style="`color:rgb(${roadCondToColor(findRoadcast(getQuarter(fcast.date)[2].timestamp, true))});`">{{ findRoadcast(getQuarter(fcast.date)[2].timestamp) || '-' }}</span></v-col>
                  <v-col v-if="user.features.includes('roadcast')" cols="3" class="text-center"> <span :title="roadCondToLongTitle(findRoadcast(getQuarter(fcast.date)[3].timestamp, true))" :style="`color:rgb(${roadCondToColor(findRoadcast(getQuarter(fcast.date)[3].timestamp, true))});`">{{ findRoadcast(getQuarter(fcast.date)[3].timestamp) || '-' }}</span></v-col>

                  <!-- temperature min -->
                  <!-- -->
                  <v-col cols="3" class="text-center">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attr }">
                        <v-icon
                          class="icon-float"
                          color="blue"
                          v-on="on"
                          v-bind="attr"
                          >mdi-thermometer</v-icon
                        >
                      </template>
                      <span>Température minimum (°C)</span>
                    </v-tooltip>
                    {{
                      Math.round(getQuarter(fcast.date)[0].tmin * 100) / 100
                    }}</v-col
                  >
                  <v-col cols="3" class="text-center">{{
                    Math.round(getQuarter(fcast.date)[1].tmin * 100) / 100
                  }}</v-col>
                  <v-col cols="3" class="text-center">{{
                    Math.round(getQuarter(fcast.date)[2].tmin * 100) / 100
                  }}</v-col>
                  <v-col cols="3" class="text-center">{{
                    Math.round(getQuarter(fcast.date)[3].tmin * 100) / 100
                  }}</v-col>

                  <!-- temperature max -->
                  <!--  -->
                  <v-col cols="3" class="text-center">
                    <v-tooltip top v-if="b == 0">
                      <template v-slot:activator="{ on, attr }">
                        <v-icon
                          class="icon-float"
                          color="red"
                          v-on="on"
                          v-bind="attr"
                          >mdi-thermometer</v-icon
                        >
                      </template>
                      <span>Température Max (°C)</span>
                    </v-tooltip>
                    {{
                      Math.round(getQuarter(fcast.date)[0].tmax * 100) / 100
                    }}</v-col
                  >
                  <v-col cols="3" class="text-center">{{
                    Math.round(getQuarter(fcast.date)[1].tmax * 100) / 100
                  }}</v-col>
                  <v-col cols="3" class="text-center">{{
                    Math.round(getQuarter(fcast.date)[2].tmax * 100) / 100
                  }}</v-col>
                  <v-col cols="3" class="text-center">{{
                    Math.round(getQuarter(fcast.date)[3].tmax * 100) / 100
                  }}</v-col>

                  <!-- pluie -->
                  <!-- -->
                  <v-col cols="3" class="text-center">
                    <v-tooltip top v-if="b == 0">
                      <template v-slot:activator="{ on, attr }">
                        <v-icon
                          class="icon-float"
                          v-on="on"
                          v-bind="attr"
                          color="blue"
                          >mdi-weather-rainy</v-icon
                        >
                      </template>
                      <span>Pluie (mm)</span>
                    </v-tooltip>
                    {{
                      Math.round(getQuarter(fcast.date)[0].apcpsfc * 100) / 100
                    }}</v-col
                  >
                  <v-col cols="3" class="text-center">{{
                    Math.round(getQuarter(fcast.date)[1].apcpsfc)
                  }}</v-col>
                  <v-col cols="3" class="text-center">{{
                    Math.round(getQuarter(fcast.date)[2].apcpsfc)
                  }}</v-col>
                  <v-col cols="3" class="text-center">{{
                    Math.round(getQuarter(fcast.date)[3].apcpsfc)
                  }}</v-col>

                  <!-- Neige -->
                  <!-- -->
                  <v-col cols="3" class="text-center">
                    <v-tooltip top v-if="b == 0">
                      <template v-slot:activator="{ on, attr }">
                        <v-icon
                          class="icon-float"
                          color="grey"
                          v-on="on"
                          v-bind="attr"
                          >mdi-snowflake</v-icon
                        >
                      </template>
                      <span>Neige (cm)</span>
                    </v-tooltip>
                    {{
                      (((Math.round(
                        getQuarter(fcast.date)[0].csnowsfc *
                          getQuarter(fcast.date)[0].apcpsfc
                      ) *
                        8) /
                        10) *
                        100) /
                      100
                    }}</v-col
                  >
                  <v-col cols="3" class="text-center">{{
                    (((Math.round(
                      getQuarter(fcast.date)[1].csnowsfc *
                        getQuarter(fcast.date)[1].apcpsfc
                    ) *
                      8) /
                      10) *
                      100) /
                    100
                  }}</v-col>
                  <v-col cols="3" class="text-center">
                    {{
                    (((Math.round(
                      getQuarter(fcast.date)[2].csnowsfc *
                        getQuarter(fcast.date)[2].apcpsfc
                    ) *
                      8) /
                      10) *
                      100) /
                    100
                  }}</v-col>
                  <v-col cols="3" class="text-center">{{
                    (((Math.round(
                      getQuarter(fcast.date)[3].csnowsfc *
                        getQuarter(fcast.date)[3].apcpsfc
                    ) *
                      8) /
                      10) *
                      100) /
                    100
                  }}</v-col>

                  <!-- Vents -->
                  <!-- -->
                  <v-col cols="3" class="text-center">
                    <v-tooltip top v-if="b == 0">
                      <template v-slot:activator="{ on, attr }">
                        <v-icon
                          class="icon-float"
                          v-on="on"
                          v-bind="attr"
                          color="blue"
                          >mdi-weather-windy</v-icon
                        >
                      </template>
                      <span>Vents moyens (km/h)</span>
                    </v-tooltip>
                    {{
                      Math.round(getQuarter(fcast.date)[0].wind_speed * 3.6)
                    }}</v-col
                  >
                  <v-col cols="3" class="text-center">{{
                    Math.round(getQuarter(fcast.date)[1].wind_speed * 3.6)
                  }}</v-col>
                  <v-col cols="3" class="text-center">{{
                    Math.round(getQuarter(fcast.date)[2].wind_speed * 3.6)
                  }}</v-col>
                  <v-col cols="3" class="text-center">{{
                    Math.round(getQuarter(fcast.date)[3].wind_speed * 3.6)
                  }}</v-col>

                  <!-- Raf -->
                  <!-- -->
                  <v-col cols="3" class="text-center">
                    <v-tooltip top v-if="b == 0">
                      <template v-slot:activator="{ on, attr }">
                        <v-icon
                          class="icon-float"
                          v-on="on"
                          v-bind="attr"
                          color="red"
                          >mdi-weather-windy</v-icon
                        >
                      </template>
                      <span>Rafales (km/h)</span>
                    </v-tooltip>
                    {{
                      Math.round(getQuarter(fcast.date)[0].gustsfc * 3.6)
                    }}</v-col
                  >
                  <v-col cols="3" class="text-center">{{
                    Math.round(getQuarter(fcast.date)[1].gustsfc * 3.6)
                  }}</v-col>
                  <v-col cols="3" class="text-center">{{
                    Math.round(getQuarter(fcast.date)[2].gustsfc * 3.6)
                  }}</v-col>
                  <v-col cols="3" class="text-center">{{
                    Math.round(getQuarter(fcast.date)[3].gustsfc * 3.6)
                  }}</v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </template>
        <template v-else>
          <v-carousel :continuous="false">
            <v-carousel-item
              :class="
                fcast.ts >= 5 && fcast.ts <= 11
                  ? 'card-weather-2'
                  : 'card-weather-1'
              "
              @click="
                selectForecast(fcast);
                openpopup = true;
              "
              v-for="(fcast, b) in forecastsDay"
              :key="`bmobile${b}`"
            >
              <v-col class="text-center white--text">
                <span class="text-h5 font-weight-bold">{{
                  moment(fcast.date).format("dddd").toUpperCase()
                }}</span>
                <v-img
                  contain
                  height="200px"
                  :src="`${iconUrl(fcast.ts)}`"
                />
              </v-col>
              <v-col class="display-1 text-center">
                <v-icon>mdi-thermometer</v-icon>
                <span class="font-weight-bold"
                  >{{ fcast.tmin }} /
                  <span class="red--text">{{ fcast.tmax }}</span
                  > °C</span
                ><br />
                <v-icon>mdi-weather-windy</v-icon>
                <span class="font-weight-bold"
                  >{{ Math.round(fcast.wind_speed * 3.6) }}/<span
                    class="info--text"
                    >{{ Math.round(fcast.gustsfc * 3.6) }}</span
                  >   km/h</span
                ><br />
                <v-icon>mdi-percent</v-icon>
                <span class="font-weight-bold blue--text"
                  >{{ Math.round(fcast.rhmax * 100) / 100 }} %</span
                >
                <br />
                <v-icon>mdi-water</v-icon>
                <span class="font-weight-bold"
                  >{{ Math.round(fcast.apcpsfc * 100) / 100 }} mm/h</span
                >
              </v-col>
            </v-carousel-item>
          </v-carousel>
        </template>
      </v-row>
    </template>
    <template v-else>
      <v-skeleton-loader type="card" />
    </template>

    <v-dialog
      light
      v-model="openpopup"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar color="primary">
          <v-spacer />
          <v-btn @click="openpopup = false" icon
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text>
        <v-row>
          <v-col
            cols="12"
            elevation="1"
            md="3"
            v-for="(quarter, z) in selectedQuarters"
            :key="`quarter${z}`"
            class="text-center"
          >
            <h1 class="py-5">
              <template v-if="z == 0">Nuit</template>
              <template v-else-if="z == 1">Matin</template>
              <template v-else-if="z == 2">Ap.midi</template>
              <template v-else-if="z == 3">Soir</template>
            </h1>
            <v-img contain :src="`${iconUrl(quarter.ts)}`" />

            <v-col class="display-1 text-center">
              <v-icon>mdi-thermometer</v-icon>
              <span class="font-weight-bold"
                >{{ Math.round(quarter.tmin) }} /
                <span class="red--text">{{ Math.round(quarter.tmax) }}</span
                > °C</span
              ><br />
              <v-icon>mdi-weather-windy</v-icon>
              <span class="font-weight-bold"
                >{{ Math.round(quarter.wind_speed * 3.6) }}/<span
                  class="info--text"
                  >{{ Math.round(quarter.gustsfc * 3.6) }}</span
                > km/h</span
              ><br />
              <v-icon>mdi-percent</v-icon>
              <span class="font-weight-bold blue--text"
                >{{ Math.round(quarter.rhmax * 100) / 100 }} %</span
              >
              <br />
              <v-icon>mdi-water</v-icon>
              <span class="font-weight-bold"
                >{{ Math.round(quarter.apcpsfc * 100) / 100 }} mm/h</span
              >
            </v-col>
          </v-col>
        </v-row>
      </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// API
import api from "../../api";

import moment from "moment";
import { mapState } from "vuex";

import { iconUrl } from "../../iconUrl";

moment.locale("fr");

export default {
  computed: {
    ...mapState(["user", "model"]),
  },
  data() {
    return {
      forecastsDay: [],
      forecastsQuarter: [],
      selected: null,
      selectedQuarters: [],
      isLoading: false,
      openpopup: false,
      roadcasts: [],
      textes:[],
    };
  },

  methods: {
    iconUrl,
    getTexte(date)
    {
      return this.textes.find((chunk) =>
          moment(chunk.date).format("YYYY-MM-DD") ===
          moment(date).format("YYYY-MM-DD"))
    },
    async getMeteoTxt(date)
    {
      let search = [];
      let quarter = [];
      quarter = this.forecastsQuarter.filter((chunk) =>
          moment(chunk.date).format("YYYY-MM-DD") ===
          moment(date).format("YYYY-MM-DD"))
          let minTemp = 999 
          let maxTemp = -999
          let rain = 0
          let gust = 0
      quarter.forEach(element=>{
        if(minTemp > element.tmin) minTemp = element.tmin;
        if(maxTemp < element.tmax) maxTemp = element.tmax;
        rain+=element.apcpsfc
        if(gust < element.gustsfc) gust = element.gustsfc;
        search.push(element.ts);
      })
      let wind = this.forecastsDay.find((chunk) =>
          moment(chunk.date).format("YYYY-MM-DD") ===
          moment(date).format("YYYY-MM-DD")).wind_speed;

      if(!search.length) return;
      let result = await api.forecast.getText(search.join(','))
      this.textes.push({
        date:date,
        text:result.txt,
        temp:[minTemp, maxTemp],
        rain:rain,
        wind:wind,
        gust:gust
      });
    },
    roadCondToTitle(e) {
      let text = null;
      e = parseInt(e);
      switch (e) {
        case 1:
          text = "SEC";
          break;
        case 2:
          text = "EAU";
          break;
        case 3:
          text = "GLA";
          break;
        case 4:
          text = "G/E";
          break;
        case 5:
          text = "ROS";
          break;
        case 6:
          text = "G/F";
          break;
        case 7:
          text = "VERG";
          break;
        case 8:
          text = "E/V";
          break;
      }
      return text;
    },
    
    roadCondToLongTitle(e) {
      let text = null;
      e = parseInt(e);
      switch (e) {
        case 1:
          text = "Sèche";
          break;
        case 2:
          text = "Mouillé";
          break;
        case 3:
          text = "Glace";
          break;
        case 4:
          text = "Mélange Glace / Eau";
          break;
        case 5:
          text = "Rosée";
          break;
        case 6:
          text = "Glace fondu";
          break;
        case 7:
          text = "Verglas";
          break;
        case 8:
          text = "Eau / Verglas";
          break;
      }
      return text;
    },

    roadCondToColor(e) {
      let color = null;
      e = parseInt(e);
      switch (e) {
        case 1:
          color = "74 157 74";
          break;
        case 2:
          color = "0 112 255";
          break;
        case 3:
          color = "50 173 187";
          break;
        case 4:
          color = "255 143 0";
          break;
        case 5:
          color = "250,145,255";
          break;
        case 6:
          color = "255, 140, 0";
          break;
        case 7:
          color = "255, 25, 0";
          break;
        case 8:
          color = "208, 18, 198";
          break;
      }
      return color;
    },
    async getForecasts() {
      this.isLoading = true;
      try {
        let dayResult = await api.forecast.get(this.$route.params.geoname, 24, this.model);
        let quarterResult = await api.forecast.get(
          this.$route.params.geoname,
          6,this.model
        );

        this.forecastsDay = dayResult.long.splice(0, 7);

        this.forecastsQuarter = quarterResult.long;
        for(const day of this.forecastsDay)
        {
          await this.getMeteoTxt(day.date);
        }
        this.selectForecast(this.forecastsDay[0]);
      } catch (err) {
        console.error(err.message);
      }
      this.isLoading = false;
    },
    getQuarter(date) {
      return this.forecastsQuarter.filter(
        (chunk) =>
          moment(chunk.date).format("YYYY-MM-DD") ===
          moment(date).format("YYYY-MM-DD")
      );
    },
    findRoadcast(timestamp, rc = false) {
      let find = this.roadcasts.find(
        (map) =>
          moment(moment(map["roadcast-time"]).unix() * 1000).format("YYYYMMDDHHmm") ==
          moment(timestamp * 1000).format("YYYYMMDDHHmm")
      );
      return find ? rc ? find.rc : this.roadCondToTitle(find.rc) : null;
    },
    async getRoadcast() {
      this.isLoading = true;
      try {
        let cityInfo = await api.cities.getinfos(this.$route.params.geoname);

        let roadcastcall = await api.roadcast.get(cityInfo.lat, cityInfo.lon);

        this.roadcasts = roadcastcall.roadcast["prediction-list"].prediction;
      } catch (err) {
        console.error(err);
      }
      this.isLoading = false;
    },
    selectForecast(forecast) {
      this.selected = forecast;

      const quarters = this.forecastsQuarter.filter(
        (chunk) =>
          moment(chunk.date).format("YYYY-MM-DD") ===
          moment(forecast.date).format("YYYY-MM-DD")
      );

      this.selectedQuarters = quarters;
    },
    moment,
  },

  async mounted() {
    await this.getForecasts();
    if (this.user.features.includes("roadcast")) {
      await this.getRoadcast();
    }
  },

  watch:{
    model()
    {
      this.getForecasts();
      if (this.user.features.includes("roadcast")) {
        this.getRoadcast();
      } 
    }
  }
};
</script>

<style>
.card-weather-1 {
  background: linear-gradient(
      135deg,
      rgb(255, 211, 101, 0.57) 10%,
      rgba(255, 255, 255, 0.938)
    )
    rgba(0, 0, 0, 0);
}
.card-weather-2 {
  background: linear-gradient(
      135deg,
      rgba(101, 224, 255, 0.57) 10%,
      rgba(157, 157, 157, 0.57)
    )
    rgba(0, 0, 0, 0);
}

.border-right {
  border-right: 1px solid rgb(214, 214, 214);
}
.icons-table.col {
  flex: none;
  width: 16px !important;
  margin-top: 400px;
}
.icon-float {
  position: absolute !important;
  left: 0px !important;
}
.v-carousel__controls {
  margin-bottom: 15px !important;
  bottom:6em;
  background-color:none;
}
.text-center.col.col-3 {
    white-space: nowrap!important;
    font-size: .7em!important;
}

.v-window.v-item-group.theme--dark.v-carousel {
    height: 93vh!important;
}

.v-carousel__controls {
    bottom: 6em;
    background: none;
}

i.v-icon.notranslate.mdi.mdi-circle.theme--dark {
    color: #b6b6b6;
}
</style>